import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'urlSanitizer'
})
export class UrlSanitizerPipe implements PipeTransform {

  private readonly sanitizer = inject(DomSanitizer);

  transform(value: any): any {
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }

}
